//auth
export const SET_TOKEN = 'SET_TOKEN';
export const REMOVE_TOKEN = 'REMOVE_TOKEN';
export const CHANGE_POPUP_RESTORE_PASSWORD = 'CHANGE_POPUP_RESTORE_PASSWORD';
export const CHANGE_POPUP_NEW_PASSWORD = 'CHANGE_POPUP_NEW_PASSWORD';
export const SET_LOADING_REGISTRATION = 'SET_LOADING_REGISTRATION';
export const CHANGE_POPUP_LDAP = 'CHANGE_POPUP_LDAP';
export const SING_IN_WITH_LDAP_LOADING = 'SING_IN_WITH_LDAP_LOADING';
export const CHECK_EMAIL_LOADING = 'CHECK_EMAIL_LOADING';

export const SHOW_GLOBAL_LOADER = 'SHOW_GLOBAL_LOADER';
export const FIX_BODY = 'FIX_BODY';
//settings
export const SET_LANGUAGE_LIST = 'SET_LANGUAGE_LIST';
export const SET_TRANSLATIONS = 'SET_TRANSLATIONS';
export const SET_CATALOG_MENU_LOADING = 'SET_CATALOG_MENU_LOADING';
export const SET_CATALOG_MENU = 'SET_CATALOG_MENU';
export const ACTIVE_CATEGORY = 'ACTIVE_CATEGORY';
export const SET_LIST_CATEGORY_FILTERS = 'SET_LIST_CATEGORY_FILTERS';
export const SET_LIST_CATEGORY_FILTERS_LOADING = 'SET_LIST_CATEGORY_FILTERS_LOADING';
//search
export const SET_HEADER_SEARCH = 'SET_HEADER_SEARCH';
export const SET_HEADER_SEARCH_LOADER = 'SET_HEADER_SEARCH_LOADER';
export const RESET_HEADER_SEARCH_TOOLTIP = 'RESET_HEADER_SEARCH_TOOLTIP';
export const SHOW_NOT_RESULT_SEARCH_HEADER = 'SHOW_NOT_RESULT_SEARCH_HEADER';
export const SET_SEARCH_LIST_LOADER = 'SET_SEARCH_LIST_LOADER';
export const SET_SEARCH_LIST = 'SET_SEARCH_LIST';
export const SHOW_NOT_RESULT_SEARCH = 'SHOW_NOT_RESULT_SEARCH';
export const RESET_SEARCH = 'RESET_SEARCH';
export const SET_QUERY_SEARCH = 'SET_QUERY_SEARCH';
export const SEARCH_CHANGE_SKIP = 'SEARCH_CHANGE_SKIP';
export const SEARCH_SET_COUNT = 'SEARCH_SET_COUNT';
//contacts
export const SET_LOADING_FEEDBACK = 'SET_LOADING_FEEDBACK';
export const SET_CONTACTS = 'SET_CONTACTS';
export const SET_CONTACTS_LOADING = 'SET_CONTACTS_LOADING';
//faq
export const SET_FAQ_LIST_LOADING = 'SET_FAQ_LIST_LOADING';
export const SET_FAQ_LIST = 'SET_FAQ_LIST';
export const SET_LOADING_ASK = 'SET_LOADING_ASK';
//catalog
export const SHOW_CATALOG_MENU = 'SHOW_CATALOG_MENU';
//system
export const SET_CUSTOM_BREADCRUMBS_LIST = 'SET_CUSTOM_BREADCRUMBS_LIST';
export const RESET_CUSTOM_BREADCRUMBS_LIST = 'RESET_CUSTOM_BREADCRUMBS_LIST';
export const CHANGE_OPEN_MENU = 'CHANGE_OPEN_MENU';
export const CHANGE_OPEN_SECOND_MENU = 'CHANGE_OPEN_SECOND_MENU';
export const CHANGE_OPEN_FIRST_MENU = 'CHANGE_OPEN_FIRST_MENU';
export const CHANGE_OPEN_FILTER = 'CHANGE_OPEN_FILTER';
export const SET_PROPS_SECOND_MENU = 'SET_PROPS_SECOND_MENU';
//home
export const SET_ADVANTAGE_LIST = 'SET_ADVANTAGE_LIST';
export const SET_ADVANTAGE_LIST_LOADING = 'SET_ADVANTAGE_LIST_LOADING';
export const GET_MAIN_SLIDER_LOADING = 'GET_MAIN_SLIDER_LOADING';
export const SET_MAIN_SLIDER = 'SET_MAIN_SLIDER';
//config
export const GET_CONFIG_LOADING = 'GET_CONFIG_LOADING';
export const SET_CONFIG = 'SET_CONFIG';
//products
export const SET_LOADING_SLIDER_PRODUCTS = 'SET_LOADING_SLIDER_PRODUCTS';
export const SET_SLIDER_PRODUCTS = 'SET_SLIDER_PRODUCTS';
//requisites
export const SET_LOADING_AVAILABILITY_PROPS = 'SET_LOADING_AVAILABILITY_PROPS';
export const SET_AVAILABILITY_PROPS = 'SET_AVAILABILITY_PROPS';
export const SHOW_POPUP_AVAILABILITY_PROPS = 'SHOW_POPUP_AVAILABILITY_PROPS';
export const DECREMENT_AVAILABILITY_PROPS = 'DECREMENT_AVAILABILITY_PROPS';
export const INCREMENT_AVAILABILITY_PROPS = 'INCREMENT_AVAILABILITY_PROPS';
export const RESET_AVAILABILITY_PROPS = 'RESET_AVAILABILITY_PROPS';
export const SET_CURRENT_REQUISITE = 'SET_CURRENT_REQUISITE';
export const SHOW_POPUP_BASKET = 'SHOW_POPUP_BASKET';
export const SET_CURRENT_DATE_REQUISITE = 'SET_CURRENT_DATE_REQUISITE';
export const SET_COUNT_AVAILABILITY_PROPS = 'SET_COUNT_AVAILABILITY_PROPS';
//basket
export const ADD_ITEM_TO_BASKET = 'ADD_ITEM_TO_BASKET';
export const REMOVE_ITEM_FROM_BASKET = 'REMOVE_ITEM_FROM_BASKET';
export const RESET_BASKET = 'RESET_BASKET';
export const SET_EDIT_BASKET_ITEM = 'SET_EDIT_BASKET_ITEM';
export const SHOW_POPUP_EDIT_TO_BASKET = 'SHOW_POPUP_EDIT_TO_BASKET';
export const CHECK_PROMO_CODE_LOADING = 'CHECK_PROMO_CODE_LOADING';
export const DECREMENT_BASKET_EDIT_COUNT = 'DECREMENT_BASKET_EDIT_COUNT';
export const INCREMENT_BASKET_EDIT_COUNT = 'INCREMENT_BASKET_EDIT_COUNT';
export const SET_BASKET_EDIT_COUNT = 'SET_BASKET_EDIT_COUNT';
export const REPLACE_ITEM_IS_BASKET = 'REPLACE_ITEM_IS_BASKET';
export const BUY_REQUISITES_LOADING = 'BUY_REQUISITES_LOADING';
export const SET_DISCOUNT = 'SET_DISCOUNT';
export const RESET_DISCOUNT = 'RESET_DISCOUNT';
export const SET_PROMO_CODE_IN_BASKET = 'SET_PROMO_CODE_IN_BASKET';
export const SHOW_POPUP_THANKS = 'SHOW_POPUP_THANKS';
export const SET_DATA_REMOVE_FROM_BASKET = 'SET_DATA_REMOVE_FROM_BASKET';
export const SHOW_POPUP_REMOVE_FROM_BASKET = 'SHOW_POPUP_REMOVE_FROM_BASKET';
export const INCREMENT_BASKET_LIST_COUNT = 'INCREMENT_BASKET_LIST_COUNT';
export const DECREMENT_BASKET_LIST_COUNT = 'DECREMENT_BASKET_LIST_COUNT';
export const SET_BASKET_LIST_COUNT = 'SET_BASKET_LIST_COUNT';
export const FRESH_BASKET_ITEMS = 'FRESH_BASKET_ITEMS';
//props selection
export const SET_LOADING_PROPS_SELECTION = 'SET_LOADING_PROPS_SELECTION';
export const SET_PROPS_SELECTION = 'SET_PROPS_SELECTION';
export const UPDATE_CHECKED_LIST_IN_PROPS = 'UPDATE_CHECKED_LIST_IN_PROPS';
export const PROPS_SELECTION_CHANGE_SKIP = 'PROPS_SELECTION_CHANGE_SKIP';
export const PROPS_SELECTION_SET_COUNT = 'PROPS_SELECTION_SET_COUNT';
export const SET_COUNT_PRODUCTS = 'SET_COUNT_PRODUCTS';
export const CHECK_COUNT_PRODUCTS_LOADING = 'CHECK_COUNT_PRODUCTS_LOADING';
export const GET_ALL_FILTERS_LOADING = 'GET_ALL_FILTERS_LOADING';
export const SET_ALL_FILTERS = 'SET_ALL_FILTERS';
export const PROPS_SELECTION_RESET_ALL = 'PROPS_SELECTION_RESET_ALL';
export const PROPS_SELECTION_CHANGE_RESET_ALL = 'PROPS_SELECTION_CHANGE_RESET_ALL';
export const PROPS_SELECTION_CHANGE_PRICE = 'PROPS_SELECTION_CHANGE_PRICE';
//popups
export const POPUP_TEXT_CONTENT = 'POPUP_TEXT_CONTENT';
export const SHOW_POPUP_TEXT_CONTENT = 'SHOW_POPUP_TEXT_CONTENT';
//category
export const SET_PRODUCTS_LIST = 'SET_PRODUCTS_LIST';
export const PRODUCTS_LIST_SET_SKIP = 'PRODUCTS_LIST_SET_SKIP';
export const SET_LOADING_PRODUCTS_LIST = 'SET_LOADING_PRODUCTS_LIST';
export const UPDATE_CHECKED_LIST_IN_PRODUCTS = 'UPDATE_CHECKED_LIST_IN_PRODUCTS';
export const PRODUCTS_CHANGE_SKIP = 'PRODUCTS_CHANGE_SKIP';
export const PRODUCTS_SET_COUNT = 'PRODUCTS_SET_COUNT';
export const REMOVE_FILTER_ITEM_IN_SEARCH = 'REMOVE_FILTER_ITEM_IN_SEARCH';
export const PRODUCTS_CHANGE_LIMIT = 'PRODUCTS_CHANGE_LIMIT';
export const SET_PRODUCT = 'SET_PRODUCT';
export const CHANGE_PRODUCT_LOADING = 'CHANGE_PRODUCT_LOADING';
export const PRODUCTS_CHANGE_VIEW = 'PRODUCTS_CHANGE_VIEW';
export const GET_CUSTOM_BREADCRUMBS_LOADING = 'GET_CUSTOM_BREADCRUMBS_LOADING';
export const SET_PRODUCTS_SORT_TYPE = 'SET_PRODUCTS_SORT_TYPE';
export const RESET_PRODUCT = 'RESET_PRODUCT';

//personal
//setting
export const SET_USER_DATA = 'SET_USER_DATA';
export const LOADING_USER_DATA = 'LOADING_USER_DATA';
//profile
export const UPDATE_USER_DATA_LOADING = 'UPDATE_USER_DATA_LOADING';
export const SHOW_POPUP_UPDATE_PASSWORD = 'SHOW_POPUP_UPDATE_PASSWORD';
export const UPDATE_USER_PASSWORD_LOADING = 'UPDATE_USER_PASSWORD_LOADING';

//orders
export const GET_ORDERS_LIST_LOADING = 'GET_ORDERS_LIST_LOADING';
export const SET_ORDERS_LIST = 'SET_ORDERS_LIST';
export const FRESH_ORDER_LIST = 'FRESH_ORDER_LIST';
export const POPUP_ORDER = 'POPUP_ORDER';
export const CANCEL_ORDER_LOADING = 'CANCEL_ORDER_LOADING';

//history
export const SET_GET_HISTORY_LIST_LOADING = 'SET_GET_HISTORY_LIST_LOADING';
export const SET_GET_HISTORY_LIST = 'SET_GET_HISTORY_LIST';

//favorites
export const SET_FAVORITES_LIST_LOADING = 'SET_FAVORITES_LIST_LOADING';
export const SET_FAVORITES_LIST = 'SET_FAVORITES_LIST';
export const FAVORITES_INCREMENT_COUNT = 'FAVORITES_INCREMENT_COUNT';
export const FAVORITES_DECREMENT_COUNT = 'FAVORITES_DECREMENT_COUNT';
export const CHANGE_POPUP_EDIT_DATE = 'CHANGE_POPUP_EDIT_DATE';
export const SET_EDIT_ITEM = 'SET_EDIT_ITEM';
export const FAVORITES_SET_EDITED_DATES = 'FAVORITES_SET_EDITED_DATES';
export const CHANGE_OPEN_FAVORITES_LIST = 'CHANGE_OPEN_FAVORITES_LIST';
export const FAVORITES_UPDATE_NAME_LIST_LOADING = 'FAVORITES_UPDATE_NAME_LIST_LOADING';
export const SET_FAVORITES_NAME_LIST = 'SET_FAVORITES_NAME_LIST';
export const FAVORITES_SHOW_POPUP_EDIT_NAME_LIST = 'FAVORITES_SHOW_POPUP_EDIT_NAME_LIST';
export const SET_EDITED_NAME_DATA = 'SET_EDITED_NAME_DATA';
export const FAVORITES_REPORT_APPERANCE_LOADING = 'FAVORITES_REPORT_APPERANCE_LOADING';
export const FAVORITES_REPORT_APPERANCE_SHOW_POPUP = 'FAVORITES_REPORT_APPERANCE_SHOW_POPUP';
export const FAVORITES_DATA_REPORT_APPERANCE = 'FAVORITES_DATA_REPORT_APPERANCE';
export const FAVORITES_CHANGE_POPUP_ADD_PERMISSIONS = 'FAVORITES_CHANGE_POPUP_ADD_PERMISSIONS';
export const FAVORITES_ADD_PERMISSIONS_LOADING = 'FAVORITES_ADD_PERMISSIONS_LOADING';
export const CHANGE_POPUP_ADD_TO_FAVORITES = 'CHANGE_POPUP_ADD_TO_FAVORITES';
export const FAVORITES_SET_NEW_WHICH_LIST = 'FAVORITES_SET_NEW_WHICH_LIST';
export const FAVORITES_SET_NEW_WHICH_LIST_LOADING = 'FAVORITES_SET_NEW_WHICH_LIST_LOADING';
export const ADD_PRODUCT_TO_FAVORITE_LOADING = 'ADD_PRODUCT_TO_FAVORITE_LOADING';
export const UPDATE_FAVORITES_LIST_AFTER_REMOVE_ITEM = 'UPDATE_FAVORITES_LIST_AFTER_REMOVE_ITEM';
export const FAVORITES_SAVE_LIST = 'FAVORITES_SAVE_LIST';
export const FRESH_FAVORITES_NAME_LIST = 'FRESH_FAVORITES_NAME_LIST';
export const FAVORITES_SORT_BY_TYPE = 'FAVORITES_SORT_BY_TYPE';
export const CHANGE_POPUP_BOOKING = 'CHANGE_POPUP_BOOKING';
export const SET_SELECTED_PRODUCTS_BOOKING = 'SET_SELECTED_PRODUCTS_BOOKING';
export const OPEN_CURRENT_LIST = 'OPEN_CURRENT_LIST';
export const SET_CURRENT_LIST_ID = 'SET_CURRENT_LIST_ID';
export const SHOW_POPUP_REMOVE_FROM_FAVORITES = 'SHOW_POPUP_REMOVE_FROM_FAVORITES';
export const SET_DATA_REMOVE_FROM_FAVORITES = 'SET_DATA_REMOVE_FROM_FAVORITES';
export const REMOVE_PRODUCT_IN_FAVORITE_LOADING = 'REMOVE_PRODUCT_IN_FAVORITE_LOADING';
export const FAVORITES_MOVE_PRODUCT_LOADING = 'FAVORITES_MOVE_PRODUCT_LOADING';
export const FAVORITES_SET_MOVING_PRODUCT = 'FAVORITES_SET_MOVING_PRODUCT';
export const FAVORITES_DOWNLOAD_LIST = 'FAVORITES_DOWNLOAD_LIST';
export const FAVORITES_GET_DOWNLOAD_LINK_LOADING = 'FAVORITES_GET_DOWNLOAD_LINK_LOADING';
export const FAVORITES_SET_ITEM_COUNT = 'FAVORITES_SET_ITEM_COUNT';
export const REMOVE_FAVORITE_LIST_LOADING = 'REMOVE_FAVORITE_LIST_LOADING';
export const UPDATE_FAVORITES_AFTER_REMOVE_LIST = 'UPDATE_FAVORITES_AFTER_REMOVE_LIST';
export const CHANGE_POPUP_FAVORITES_REMOVE_LIST = 'CHANGE_POPUP_FAVORITES_REMOVE_LIST';
export const FAVORITES_FRESH_LIST = 'FAVORITES_FRESH_LIST';

